import PropTypes from 'prop-types';

import { EN_US, FR_FR, DE_DE, ES_ES } from '../utils/constants/LanguageRegionCode';

export default PropTypes.oneOf([EN_US, FR_FR, DE_DE, ES_ES]);
